export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9488.063a08f5.jpg";